import { reduxHelper } from 'utils/reduxHelper';

import {
    MCS_SERVICES,
    PermissionSelectors,
} from 'reactApp/modules/PermissionsModule/PermissionsModule';

const modifyProject = PermissionSelectors.checkPermissions({
    modify: [MCS_SERVICES.project],
});

export const ProjectPermissionsSelectors = {
    getPermissions(state) {
        return {
            modifyProject: modifyProject(state),
        };
    },
};

export const BoundProjectPermissionsSelectors = reduxHelper.bindSelectors<
    typeof ProjectPermissionsSelectors
>(ProjectPermissionsSelectors);
